/*
 *   File : secondary.js
 *   Author : https://evoqins.com
 *   Description : secondary button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { Icon } from "../Icon";

// Assets
import Loader from "../../Assets/Images/loader-blue.gif";

function SecondaryButton(props) {
    return (
        props.type === 2 ?
            <button className={`${props.className} ${props.disabled ? "cursor-default opacity-7" : ""} bg-transparent e-secondary-btn cursor-pointer ${props.borderRadius || "e-border-radius-10"} e-border-otp-active e-text-egyptian-blue e-alt-font-poppins e-font-weight-400  e-btn-custom-wrapper`}
                data-bs-toggle={props.toggle}
                data-bs-target={props.target}
                data-bs-cancel={props.cancel}
                data-bs-dismiss={props.dismiss}
                disabled={props.disabled}
                id={props.id}
                onClick={props.onPress}>
                {
                    props.loading ? (
                        <img src={Loader}
                            width={22}
                            height={22}
                            className='object-fit-contain position-relative z-1'
                            draggable="false" />
                    ) : (
                        <>
                            <Icon icon={props.icon} size={props.size} />
                            {props.name}
                        </>
                    )
                }

            </button>
            :
            <button className={`${props.className} e-secondary-btn cursor-pointer ${props.disabled ? "cursor-default opacity-7" : ""} ${props.borderRadius || "e-border-radius-24"} e-bg-white border-transparent e-text-dark-charcoal e-alt-font-poppins e-font-weight-600 line-height-24px e-btn-custom-wrapper`}
                data-bs-toggle={props.toggle}
                data-bs-target={props.target}
                data-bs-cancel={props.cancel}
                data-bs-dismiss={props.dismiss}
                disabled={props.disabled}
                id={props.id}
                onClick={props.onPress}>
                {
                    props.loading ? (
                        <img src={Loader}
                            width={22}
                            height={22}
                            className='object-fit-contain position-relative z-1'
                            draggable="false" />
                    ) :
                        props.name

                }

            </button>

    )
};

SecondaryButton.defaultProps = {
    onPress: () => { },
    className: null,
    id: null,
    name: null,
    icon: null
}

export default SecondaryButton;

